import { cloneDeep } from 'lodash-es';
import routes from '@/router/routes';

// breadcrumb
const cloneRoutes = cloneDeep(routes);
const routeNameMapping = {};
const iterateRoute = (routeList) => {
  routeList.forEach((r) => {
    if (r.children) {
      iterateRoute(r.children);
    }

    routeNameMapping[r.name] = r.meta.title;
  });
};

iterateRoute(cloneRoutes);

// sitemap
const cloneRoutes2 = cloneDeep(routes).filter((r) => r.meta.siteMap.show);

const siteMapConfig = cloneRoutes2.map((r) => {
  let subList = [];

  // 第一層
  if (r.children) {
    subList = r.children.filter((r2) => !r2.meta?.hideInMenu).map((item) => {
      let subListChildren = null;

      // 第二層
      if (item.children) {
        subListChildren = item.children
          .filter((item2) => item2.meta.showInMenuChild)
          .map((item2) => ({
            label: item2.meta.title,
            route: {
              name: item2.name,
            },
          }));
      }

      return {

        label: item.meta.title,
        route: {
          name: item.name,
        },
        subListChildren,
      };
    });
  }

  return {
    name: r.name,
    label: r.meta.siteMap.title,
    order: r.meta.siteMap?.order || 0,
    subList,
  };
});

siteMapConfig.sort((a, b) => a.order - b.order);

export {
  routeNameMapping,
  siteMapConfig,
};
